export enum StopPileStatEventType {
  BUS_STOP_CHECKED,
  BUS_STOP_MISSED,
  DOOR_OUTSIDE_ZONE,
  LATE_COUNTERS,
  ZONE_MISSED,
  ENTER_ZONE,
  EXIT_ZONE_BUS_STOP_CHECKED,
  EXIT_ZONE_BUS_STOP_MISSED,
  COURSE_SELECTED,
  COURSE_ENDED,
  CLOSE_DOORS_IN_ZONE,
  CLOSE_DOORS_OUTSIDE_ZONE,
  OPEN_DOORS_IN_ZONE,
  OPEN_DOORS_OUTSIDE_ZONE,
  UPDATE_COUNTERS,
  DIRECTION_SELECTED,
  UNREGISTERED,
  DOOR_ENABLED,
  DOOR_DISABLED,
  BUS_STOP_CHECKED_WITH_HOT_BUTTON
}
